import {
  AnimationMixer,
  MathUtils,
  Mesh,
  MeshBasicMaterial,
  Object3D,
  ShaderMaterial,
} from 'three';
import { GLTF } from 'three/examples/jsm/loaders/GLTFLoader';
import { FPS } from './xjsj-scene';
import gsap from 'gsap';

export class EnterAnimContoller {
  mixer: AnimationMixer;
  meshes: Object3D[] = [];
  isAnimating = true;
  constructor(gltf: GLTF) {
    this.mixer = new AnimationMixer(gltf.scene);
    const enterClips = gltf.animations.filter(clip =>
      clip.name.includes('enter')
    );
    enterClips.forEach(clip => {
      this.mixer.clipAction(clip).play();
    });
    this.mixer.setTime(0);
    this.meshes = enterClips.map(clip => {
      const trackName = clip.tracks[0].name;
      const meshName = trackName.split('.')[0];
      return gltf.scene.getObjectByName(meshName) as Object3D;
    });
  }
  setVisiable(visiable: boolean) {
    this.meshes.forEach(mesh => {
      if (mesh) {
        mesh.visible = visiable;
      }
    });
  }
  play(callback: () => void, inSec: number) {
    // console.log('ENTER CAM CTR START');
    this.isAnimating = true;
    const animData = { t: 0 };
    const duration = 100 / FPS;
    return new Promise<void>((res, rej) => {
      gsap
        .timeline()
        .to(animData, {
          t: duration,
          duration,
          onUpdate: () => {
            this.mixer.setTime(animData.t);
            this.meshes.forEach(mesh => {
              if (mesh && mesh instanceof Mesh) {
                const mat = mesh.material;
                if (mat instanceof MeshBasicMaterial) {
                  mat.opacity =
                    1 -
                    MathUtils.smootherstep(animData.t, duration / 2, duration);
                } else if (
                  mat instanceof ShaderMaterial &&
                  mat.uniforms.opacity
                ) {
                  mat.uniforms.opacity.value =
                    1 - MathUtils.smootherstep(animData.t, 0, duration * 0.7);
                }
              }
            });
          },
          onComplete: () => {
            this.isAnimating = false;
            this.meshes.forEach(mesh => {
              mesh.visible = false;
            });
            res();
          },
        })
        .to(
          {},
          {
            duration: inSec,
            onComplete: () => {
              callback && callback();
            },
          },
          '<'
        );
    });
  }
}
